import React from 'react';
import iconExport from './images/export.svg';
import iconImport from './images/import.svg';
import styles from './button.module.scss';

const icons: any = {
  export: iconExport,
  import: iconImport,
};

const ButtonExport = ({
  type,
  onClick,
  isLoading = false,
  disabled = false,
} : {
  type: string,
  onClick: () => void,
  isLoading?: boolean,
  disabled?: boolean,
}) => (
  <button
    className={styles.button}
    onClick={onClick}
    disabled={disabled || isLoading}
    aria-busy={isLoading}
  >
    {isLoading ? <span className={styles.loader} aria-hidden="true" /> : <img src={icons[type]} alt={type} />}
  </button>
);

export default ButtonExport;
